/** Shared by the account pages: Identity's password errors and single-use token links. */
import { useEffect, useRef } from "react";

import { ApiError } from "@/lib/http";

export function passwordError(err: unknown): string | undefined {
  if (!(err instanceof ApiError)) return undefined;
  if (err.reason === "PASSWORD_BREACHED") return "This password appeared in a data breach. Choose another.";
  return err.fieldError("password") ?? err.fieldError("new_password");
}

/** Runs a token-consuming mutation exactly once (links are single-use; StrictMode mounts twice). */
export function useOnce(run: () => void) {
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    run();
  }, [run]);
}
